module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAwklEQVQYlVXQsUpCARgF4K/LHV0KGwwnQWr3AepJGtwdjIYko0UkN2kohyL0KdykBwiiySU3I1Khoa2iBv9Lt7Ocn5/DOYezUW1NlhigbY0BDrAnhwQjnKIRvyF28ZgXpjjCGy7xhWtUMMMDapkQLuK+widuInqKe+ynf+Y6eMEtCuhjGws8Jf5jHrwZvMQ3dvLCOsY4wzm28INnFDPhYUR2o0IBK7xmMyVoxiS9mKmK94gth6skXO5wEu7H+EAp+oFf/ZIqtE4xrLMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/moreB.png
// module id = 9qL6
// module chunks = 1